// TODO: Remove once we enable support for Object.values
export default function ObjectValues(object) {
    const ret = [];
    for (const key in object) {
        if (object.hasOwnProperty(key) && object.propertyIsEnumerable(key)) {
            ret.push(object[key]);
        }
    }
    return ret;
}
